module.exports = "/images/data-preview@2x.png?c406761fb0b90259acdf3d09f6b5e3b0";